import { useSWRConfig } from "swr";

export function useRefreshUser() {
  const { mutate } = useSWRConfig();
  const refresh = () => {
    mutate('/auth/me')
  }
  return refresh;
}